/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateDataExportRouteForm,
  CreateDataExportRouteForm$Outbound,
  CreateDataExportRouteForm$outboundSchema,
} from "../components/createdataexportrouteform.js";

export type CreateDataExportRouteSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateDataExportRouteSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateDataExportRouteSecurity = {
  option1?: CreateDataExportRouteSecurityOption1 | undefined;
  option2?: CreateDataExportRouteSecurityOption2 | undefined;
};

export type CreateDataExportRouteRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createDataExportRouteForm: CreateDataExportRouteForm;
};

/** @internal */
export type CreateDataExportRouteSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateDataExportRouteSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateDataExportRouteSecurityOption1$Outbound,
  CreateDataExportRouteSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createDataExportRouteSecurityOption1ToJSON(
  createDataExportRouteSecurityOption1: CreateDataExportRouteSecurityOption1,
): string {
  return JSON.stringify(
    CreateDataExportRouteSecurityOption1$outboundSchema.parse(
      createDataExportRouteSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateDataExportRouteSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateDataExportRouteSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateDataExportRouteSecurityOption2$Outbound,
  CreateDataExportRouteSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createDataExportRouteSecurityOption2ToJSON(
  createDataExportRouteSecurityOption2: CreateDataExportRouteSecurityOption2,
): string {
  return JSON.stringify(
    CreateDataExportRouteSecurityOption2$outboundSchema.parse(
      createDataExportRouteSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateDataExportRouteSecurity$Outbound = {
  Option1?: CreateDataExportRouteSecurityOption1$Outbound | undefined;
  Option2?: CreateDataExportRouteSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateDataExportRouteSecurity$outboundSchema: z.ZodMiniType<
  CreateDataExportRouteSecurity$Outbound,
  CreateDataExportRouteSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateDataExportRouteSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateDataExportRouteSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createDataExportRouteSecurityToJSON(
  createDataExportRouteSecurity: CreateDataExportRouteSecurity,
): string {
  return JSON.stringify(
    CreateDataExportRouteSecurity$outboundSchema.parse(
      createDataExportRouteSecurity,
    ),
  );
}

/** @internal */
export type CreateDataExportRouteRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateDataExportRouteForm: CreateDataExportRouteForm$Outbound;
};

/** @internal */
export const CreateDataExportRouteRequest$outboundSchema: z.ZodMiniType<
  CreateDataExportRouteRequest$Outbound,
  CreateDataExportRouteRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createDataExportRouteForm: CreateDataExportRouteForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createDataExportRouteForm: "CreateDataExportRouteForm",
    });
  }),
);

export function createDataExportRouteRequestToJSON(
  createDataExportRouteRequest: CreateDataExportRouteRequest,
): string {
  return JSON.stringify(
    CreateDataExportRouteRequest$outboundSchema.parse(
      createDataExportRouteRequest,
    ),
  );
}
